import React from 'react';
import ReactDOM from 'react-dom';
import { useEffect, useState } from "react"
import {Container, Row, Col, Button, Card, CardDeck, Jumbotron} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Research.css";
// import DropdownSelection from "../../components/DropdownSelection/DropdownSelection.js"
import * as Icon from 'react-bootstrap-icons';
// import {FormControl, Select, InputLabel, MenuItem, SelectChangeEvent, OutlinedInput, Checkbox, ListItemText} from '@mui/material';
import pdfFile from "../../assets/PDFs/manuscript_ReStud_CondAccept.pdf"
import pptFile from "../../assets/PDFs/MullerVerner_20220330_UMD.pdf"
import { CheckCircleIcon, InformationCircleIcon } from '@heroicons/react/20/solid'
import { Helmet } from 'react-helmet';

window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

const Methodology = () => {
  const isMobile = window.mobileAndTabletCheck();

    return (
      <Container className="method dark:bg-gray-900">
        <Helmet>
            <title>Research | Global Credit Project</title>
        </Helmet>
        <section className="w-3/4 max-w-screen-xl dark:text-gray-100">
          <p className="text-left mt-4 border-l-2 border-blue-800 px-3 text-base mx-auto max-w-screen-xl">
                The Global Credit Project is the result of a research agenda exploring the link between credit markets 
          and the macroeconomy around the globe. The key finding from our research is that the allocation of credit, 
          or where in the economy credit flows, is important for understanding whether credit expansions are associated 
          with deep economic crises or not.
            <br/>
            <br/>
                Below, we present the first paper of this research agenda, which has been conditionally accepted for publication 
          at the <i>Review of Economic Studies</i>. The paper also includes an extensive data appendix describing how we 
          constructed the data we make publicly available on this website.

          </p>
          <div class="gap-16 items-start py-2 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-2 lg:px-6">
            <div class="font-light mt-4 text-gray-500 sm:text-lg dark:text-gray-400">
                <h3 className="text-left text-2xl mt-0 mb-3 text-gray-800 dark:text-white">Abstract</h3>

                <p className="text-left">
            We study the relationship between credit expansions, macroeconomic fluctuations, and financial crises 
            using a novel database on the sectoral distribution of private credit for 117 countries since 1940. 
            We document that, during credit booms, credit flows disproportionately to the non-tradable sector. 
            Credit expansions to the non-tradable sector, in turn, systematically predict subsequent growth 
            slowdowns and financial crises. In contrast, credit expansions to the tradable sector are associated 
            with sustained output and productivity growth without a higher risk of a financial crisis. To 
            understand these patterns, we show that firms in the non-tradable sector tend to be smaller, more 
            reliant on loans secured by real estate, and more likely to default during crises. Our findings are 
            consistent with models in which credit booms to the non-tradable sector are driven by easy financing 
            conditions and amplified by collateral feedbacks, contributing to increased financial fragility and 
            a boom-bust cycle.
            </p>

            </div>
          
            <div class="gap-4 mt-4 mb-5 self-start">
                <h3 className="text-left text-xl">Resources</h3>
                
                <h2 className="text-left text-base">Paper: Credit Allocation and Macroeconomic Fluctuations</h2>
                <p className="text-left text-sm">
                <a href={pdfFile} target='_blank' rel="noreferrer">Download Paper</a>
                <br />
                <a>Download data appendix</a>
                </p>
                {!isMobile &&
                <embed className="h-[500px] w-full" src={pdfFile} type="application/pdf"></embed>
                }
            </div>

          </div>

        </section>


                
      </Container>
    ); 
}

export default Methodology


